const base = [
  {
    title: "25cm NY Style",
    price: 8.99
  },
  {
    title: "30cm NY Style",
    price: 11.49
  },
  {
    title: "35cm NY Style",
    price: 13.49
  }
]

const sauce = [
  {
    title: "White sauce",
    price: 0
  },
  {
    title: "Red sauce",
    price: 1
  },
  {
    title: "Mix it up",
    price:  1.50
  }
]

const toppings = [
  {
    title: "Pineapple",
    price: 0.50
  },
  {
    title: "Corn",
    price: 0.50
  },
  {
    title: "Olives (green)",
    price: 0.50
  },
  {
    title: "Red onion",
    price: 0.50
  },
  {
    title: "Spinach",
    price: 0.50
  },
  {
    title: "Cherry tomatoes",
    price: 0.50
  }
]

export {base, sauce, toppings}


// WEBPACK FOOTER //
// ./src/lib/pizzaData.js